module.exports = __webpack_public_path__ + "media/customizations/regencyatstonebrook/logo-new-115e3750fd0a6908e7be6c7f73c1f9db.png";